import { render, staticRenderFns } from "./VTableCorrectorsDone.vue?vue&type=template&id=00b63cef"
import script from "./VTableCorrectorsDone.vue?vue&type=script&lang=js"
export * from "./VTableCorrectorsDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports